import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-table-footer',
    templateUrl: './table-footer.component.html',
    styleUrls: ['./table-footer.component.scss'],
    standalone: false,
})
export class TableFooterComponent extends MatPaginator implements OnInit, OnChanges {
    @Input() public selectedItemsCount = 0;
    @Input() public showPagination = true;
    @Input() public changeToPrevPage = false;
    @Output() public refreshTable: EventEmitter<any> = new EventEmitter();

    public itemsPerPage = 10;
    public currentDisplayedPage = 1;

    get RangeStart(): number {
        const itemsFound = this.length ? 1 : 0;

        return this.pageIndex * this.pageSize + itemsFound;
    }

    get RangeEnd(): number {
        return Math.min(this.length, (this.pageIndex + 1) * this.pageSize);
    }

    get PageNumberOptions(): Array<number> {
        return Array(this.getNumberOfPages())
            .fill(0)
            .map((val, pos) => pos + 1);
    }

    ngOnInit() {
        super.ngOnInit();

        /* manage the page event in case an external source (e.g. filters) changes the pagination */
        this.page.subscribe((event: PageEvent) => {
            this.currentDisplayedPage = event.pageIndex + 1;
            this.pageIndex = event.pageIndex;
            this.pageSize = event.pageSize;
            this.length = event.length;
        });
    }

    public emitRefreshTableEvent(): void {
        this.refreshTable.emit(null);
    }

    public onCurrentPageChange(newValue: number) {
        this.pageIndex = newValue - 1;

        this.emitPageEvent();
    }

    public onItemsPerPageChange(newValue: number) {
        const firstDisplayedItemIndex = this.pageSize * this.pageIndex;

        this.pageSize = newValue;
        this.pageIndex = Math.floor(firstDisplayedItemIndex / newValue);

        this.currentDisplayedPage = this.pageIndex + 1;

        this.emitPageEvent();
    }

    public onPreviousPageEvent(): void {
        this.pageIndex = Math.max(0, this.pageIndex - 1);

        this.currentDisplayedPage = this.pageIndex + 1;

        this.emitPageEvent();
    }

    public onNextPageEvent(): void {
        this.pageIndex = Math.min(this.getNumberOfPages() - 1, this.pageIndex + 1);

        this.currentDisplayedPage = this.pageIndex + 1;

        this.emitPageEvent();
    }

    emitPageEvent() {
        const event: PageEvent = {
            length: this.length,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
        };
        this.page.next(event);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.changeToPrevPage) {
            this.onPreviousPageEvent();
        }
    }
}
